import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    background: "#FF7E67",
    borderRadius: 15,
    boxShadow: "5px 5px 50px rgba(0, 0, 0, 0.25)",
    color: "white",
    padding: "12px 60px",
    "&:hover": {
      background: "#fd6044",
    },
    "&:disabled": {
      opacity: 0.5,
      color: "white",
    },
  },
});

const PrimaryButton = (props) => {
  const classes = useStyles();
  return (
    <Button
      onClick={props.onClick}
      size={props.size}
      disabled={props.isDisabled}
      className={`${classes.root} ${props.styleClasses}`}
      style={props.style}
    >
      {props.innerText}
    </Button>
  );
};

export default PrimaryButton;
